import styled from 'styled-components';

export const WrapperBlog = styled.div`
  font-family: Montserrat;

  display: flex;

  align-items: center;

  justify-content: center;

  background-color: #F5F8FF;

  .container {
    display: flex;
    padding-top: 38px;
    padding-right: 21px;
    padding-bottom: 38px;
    align-items: center;
    width: 100%;

    @media (max-width: 1000px) {
      div.cta-image {
        display: none !important;
      }

      div.cta-text {
        width: 100% !important;
        .webinar-info {
          max-width: 324px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-left: 0;
          text-align: center;
          
          h1 {
            font-size: 32px;
          }
          
          p {
            &.light {
              font-size: 16px;
            }

            &.heavy {
              font-weight: 700;
            }
          }
        }
      }
    }

    .webinar-info {
      max-width: 560px;
      margin-left: 100px;

      span {
        background: rgba(255, 191, 45, 0.1);
        border: 1px solid #FFBF2D;
        border-radius: 5px;
        padding: 8px 16px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        color: rgba(248, 130, 11, 0.75);
      }
      h1 {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 56px;
        color: #000000;
      }
      p {
        font-family: 'Montserrat';
        font-style: normal;
        font-size: 24px;
        color: #545C68;

        &.light {
          font-weight: 400;
        }

        &.heavy {
          font-weight: 700;
        }
      }
      button {
        width: 324px;
        height: 60px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 19.2px;
        text-align: center;
        color: #FFFFFF;
        background: #2253F5;
        border-radius: 5px;
        border: none;
        cursor: pointer;
      }
    }
/* 
    .imageContainer {
      width: 100%;

      padding-right: 4rem;

      max-height: 25rem;

      display: flex;

      justify-content: flex-end;

      border: 5px solid #fcff7c;
      border-left: none;
      border-radius: 0px 99999px 99999px 0px;

      background-color: #ffffff;

      img {
        max-width: 80%;
        height: auto;
      }

      @media (min-width: 1400px) {
        padding-right: 6rem;
      }
    }

    .textContainer {
      width: 100%;

      display: flex;
      flex-direction: column;

      font-family: Montserrat;

      .title {
        font-weight: normal;
        font-size: 2rem;

        color: #fcff7c;

        @media (max-width: 1400px) {
          font-size: 1.5rem;
        }

        @media (max-width: 1180px) {
          font-size: 1.2rem;
        }

        @media (max-width: 1000px) {
          font-size: 1rem;
        }

        @media (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }

      .midText {
        line-height: normal;

        font-weight: bold;

        font-size: 3rem;

        margin-top: 16px;

        margin-bottom: 32px;

        text-align: left;

        @media (max-width: 1400px) {
          font-size: 2.5rem;
        }

        @media (max-width: 1180px) {
          font-size: 2rem;
        }

        @media (max-width: 1000px) {
          font-size: 1.5rem;
        }

        @media (max-width: 768px) {
          font-size: 1.5rem;
          text-align: center;
        }
      }

      @media (max-width: 768px) {
        align-items: center;
        margin-left: 0;
      }

      .downloadKit {
        width: 24.375rem;
        text-decoration: none;
      }

      h1 {
        color: #ffffff;
        margin: 0;
      }

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        cursor: pointer;

        font-weight: bold;
        background: #fcff7c;
        color: #2253f5;
        width: 24.375rem;
        height: 2.5rem;

        @media (max-width: 1400px) {
          width: 20rem !important;
        }

        @media (max-width: 1180px) {
          width: 16rem !important;
        }

        @media (max-width: 1000px) {
          width: 12rem !important;
        }
      } 
    }*/
  }
`;

export const Category = styled.div`
  font-family: Montserrat;
  position: relative;
  max-width: 1300px;
  margin: 0 auto;

  .image-email {
    margin-top: 4px;
    margin-right: 9px;
  }

  .list-container {
    position: absolute;
    left: 26.875rem;
    top: 4rem;
    width: 220px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }

  .list-items {
    padding: 1.3rem;
    display: flex;
    flex-direction: column;

    position: relative;

    .newsletter {
      width: 100%;
      height: 40px;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1rem;
      text-transform: capitalize;
      font-weight: bold;
      color: #2253f5;
      background: #fcff7c;
      border-radius: 100px;
    }

    p {
      margin-bottom: -0.5rem;
      font-weight: 300;
      font-size: 16px;
      color: #2253f5;
    }

    a {
      text-decoration: none;
      font-size: 14px;
      color: #333333;
      text-transform: uppercase;
      margin-top: 1.5625rem;
      cursor: pointer;

      transition: all 0.2s ease-in-out;
    }

    a:hover {
      color: #2253f5;
      font-weight: bold;
      transform: scale(1.05);
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const CategoryThree = styled.div`
  font-family: Montserrat;
  position: relative;
  max-width: 1300px;
  margin: 0 auto;

  .list-container_result {
    position: absolute;
    left: 66.5rem;
    top: -4.13rem;
    width: 220px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }

  .list-items_result {
    padding: 1.3rem;
    display: flex;
    flex-direction: column;

    .newsletter_result {
      width: 100%;
      height: 40px;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1rem;
      text-transform: capitalize;
      font-weight: bold;
      color: #2253f5;
      background: #fcff7c;
      border-radius: 100px;
    }

    p {
      margin-top: 0.7rem;
      margin-bottom: -0.6rem;
      font-weight: 300;
      font-size: 16px;
      color: #2253f5;
    }

    a {
      text-decoration: none;
      font-size: 14px;
      color: #333333;
      text-transform: uppercase;
      margin-top: 1.4rem;
      line-height: 140.62%;
      cursor: pointer;

      transition: all 0.2s ease-in-out;
    }

    a:hover {
      color: #2253f5;
      font-weight: bold;
      transform: scale(1.05);
    }
  }
  @media (max-width: 768px) {
    display: none;

    .list-container_result {
      display: none;
    }
  }
`;

export const BlogNumbers = styled.div`
  .containernumber {
    display: flex;
    justify-content: center;
    // //margin-top:109px;
  }

  a {
    margin: 200px 42px 300px 0px;
    font-family: Montserrat;
    font-size: 24px;
    font-weight: normal;
    background: #fff;
    color: #2253f5;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .containernumber {
      margin-top: 60px;
    }

    a {
      font-size: 24px;
      margin: 0 22px 100px;
    }
  }
`;

export const NoResults = styled.div`
  font-family: Montserrat;
  position: relative;
  max-width: 1300px;
  height: auto;
  margin: 0 auto;
  margin-top: 6.25rem;

  .posts-content {
    display: flex;
    align-items: center;
    margin-left: 0.13rem;
    margin-top: 2rem;

    &:last-child {
      margin-bottom: 8.5rem;
    }

    a {
      text-decoration: none;
    }
  }

  .category-information {
    width: 33.5rem;
    margin-left: 1.8125rem;

    a {
      text-decoration: none;

      h2 {
        font-size: 1.7rem;
        color: #333333;
        line-height: 38px;

        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      p {
        font-weight: 300;
        font-size: 1rem;
        line-height: 25px;
        margin-top: -0.3rem;
        color: #333333;

        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }

    h3 {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12.645px;
      color: #2253f5;
    }
  }

  .list-container {
    position: absolute;
    left: 67.5rem;
    top: 0.1rem;
    width: 219.8px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }

  .list-items {
    padding: 1.3rem;
    display: flex;
    flex-direction: column;

    .newsletter {
      width: 100%;
      height: 40px;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1rem;
      text-transform: capitalize;
      font-weight: bold;
      color: #2253f5;
      background: #fcff7c;
      border-radius: 100px;
    }

    p {
      margin-bottom: -0.5rem;
      font-weight: 300;
      font-size: 16px;
      color: #2253f5;
    }

    a {
      text-decoration: none;
      font-size: 14px;
      color: #333333;
      text-transform: uppercase;
      margin-top: 1.5625rem;
      cursor: pointer;

      transition: all 0.2s ease-in-out;
    }

    a:hover {
      color: #2253f5;
      font-weight: bold;
      transform: scale(1.05);
    }
  }

  .container-results {
    max-width: 1268px;
    overflow: hidden;
    color: #64728c;

    section.section-posts {
      margin-top: 19.625rem;
      width: 100%;
      background: #fff;

      h1 {
        margin-bottom: 4.375rem;
        font-weight: bold;
        font-size: 2.5rem;
        color: #2253f5;
        text-transform: uppercase;
      }

      div.post {
        display: flex;
        justify-content: center;
        max-width: 1300px;
        margin: 0 auto;
        gap: 76px;

        .cardblog {
          width: 316px;
          height: 434px;
          background: #fff;
          box-shadow: 0px 3.67108px 14.6843px rgba(0, 0, 0, 0.15);
          border-radius: 11.0132px;
          margin-bottom: 100px;
          overflow: hidden;

          img {
            width: auto;
            height: auto;
            display: block;
            object-fit: cover;
            cursor: pointer;
            transition: 0.75s;
          }

          img:hover {
            transform: scale(1.2);
          }
        }

        .card_items {
          padding: 20px;

          h2 {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            font-size: 18px;
            color: #333333;
            line-height: 23px;
            margin-top: 1rem;

            a {
              cursor: pointer;
              color: #333333;
            }
          }

          h3 {
            cursor: pointer;
            text-transform: uppercase;
            font-size: 11.2776px;
            margin-top: -0.2rem;
            a {
              color: #2253f5;
            }
          }

          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;

            font-size: 13px;
            color: #333333;
            margin-top: -3px;
          }
        }
        @media (max-width: 768px) {
          margin: 0 auto;
          flex-direction: column;
          align-items: center;

          .cardblog {
            width: 280px;
            height: 400px;
            margin-right: 20px;

            &:last-child {
              margin-bottom: 2rem;
            }
          }
        }
      }
    }

    img {
      margin-left: 0.1rem;
      margin-right: 0.4rem;
    }

    a {
      text-decoration: none;
      color: #64728c;
    }

    .steps-results {
      display: flex;
      align-items: center;
      color: #64728c;
    }

    margin: 0 auto;
    .list-results {
      h1 {
        font-size: 28px;
        color: #2253f5;
        font-weight: normal;
      }
    }
  }

  @media (max-width: 768px) {
    .container-results {
      margin-left: 1rem;
    }
    .list-container {
      display: none;
    }
    .title-recommended > h1 {
      font-size: 1.5rem;
    }
  }
`;

export const ContainerSearch = styled.div`
  position: relative;
  font-family: Montserrat;
  max-width: 1300px;
  height: auto;
  margin: 0 auto;

  .steps_result {
    display: flex;
    align-items: center;
    color: #64728c;

    img {
      margin-left: 0.1rem;
      margin-right: 0.4rem;
    }

    &:last-of-child {
      margin-left: 1rem;
    }
  }

  .container-result {
    max-width: 1268px;
    margin: 0 auto;
  }

  .title_result > h1 {
    font-size: 1.75rem;
    font-weight: normal;
    color: #2253f5;
    strong {
      &:first-child {
        margin: 0.4rem;
      }

      &:last-child {
        margin: 0.4rem;
      }
    }
  }

  .posts-content_result {
    display: flex;
    align-items: center;
    margin-left: 0.13rem;
    margin-top: 2.5rem;

    &:last-child {
      margin-bottom: 8.5rem;
    }

    a {
      text-decoration: none;
    }

    .category-information_result {
      width: 33.5rem;
      margin-left: 1.8125rem;

      a {
        text-decoration: none;

        h2 {
          font-size: 1.7rem;
          color: #333333;
          line-height: 38px;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        p {
          font-weight: 300;
          font-size: 1rem;
          line-height: 25px;
          margin-top: -0.3rem;
          color: #333333;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }

      h3 {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12.645px;
        color: #2253f5;
      }
    }
  }

  .list-container {
    position: absolute;
    left: 1080px;
    top: 2px;
    width: 220px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }

  .list-items {
    padding: 1.3rem;
    display: flex;
    flex-direction: column;

    .newsletter {
      width: 100%;
      height: 40px;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1rem;
      text-transform: capitalize;
      font-weight: bold;
      color: #2253f5;
      background: #fcff7c;
      border-radius: 100px;
    }

    p {
      margin-bottom: -0.5rem;
      font-weight: 300;
      font-size: 16px;
      color: #2253f5;
    }

    a {
      text-decoration: none;
      font-size: 14px;
      color: #333333;
      text-transform: uppercase;
      margin-top: 1.5625rem;
      cursor: pointer;

      transition: all 0.2s ease-in-out;
    }

    a:hover {
      color: #2253f5;
      font-weight: bold;
      transform: scale(1.05);
    }
  }

  .container-results {
    max-width: 1268px;
    margin: 0 auto;
    margin-top: 6.25rem;
    height: 100%;

    .posts-content {
      display: flex;
      align-items: center;
      margin-left: 0.13rem;
      margin-top: 2rem;

      &:last-child {
        margin-bottom: 8.5rem;
      }

      a {
        text-decoration: none;
      }
    }

    .category-information {
      width: 33.5rem;
      margin-left: 1.8125rem;

      a {
        text-decoration: none;

        h2 {
          font-size: 1.7rem;
          color: #333333;
          line-height: 38px;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        p {
          font-weight: 300;
          font-size: 1rem;
          line-height: 25px;
          margin-top: -0.3rem;
          color: #333333;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }

      h3 {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12.645px;
        color: #2253f5;
      }
    }

    .steps-result {
      display: flex;
      align-items: center;
      color: #64728c;

      img {
        margin: 0.5rem;
      }
    }

    .steps-result_slug {
      display: flex;
      align-items: center;
      color: #64728c;
      img {
        margin-left: 0.1rem;
        margin-right: 0.4rem;
      }
    }

    .title-search > h1 {
      font-weight: bold;
      font-size: 2.5rem;
      margin-bottom: 4.375rem;
      color: #2253f5;
      text-transform: uppercase;
    }
  }

  section.section-posts {
      width: 100%;
      background: #fff;

      h1 {
        margin-bottom: 4.375rem;
        font-weight: bold;
        font-size: 2.5rem;
        color: #2253f5;
        text-transform: uppercase;
      }

      div.post {
        display: flex;
        justify-content: center;
        max-width: 1300px;
        margin: 0 auto;
        gap: 76px;
        a:-webkit-any-link {
          text-decoration: none;
        }

        .cardblog {
          width: 316px;
          height: 434px;
          background: #fff;
          box-shadow: 0px 3.67108px 14.6843px rgba(0, 0, 0, 0.15);
          border-radius: 11.0132px;
          margin-bottom: 100px;
          overflow: hidden;

          img {
            width: auto;
            height: auto;
            display: block;
            object-fit: cover;
            cursor: pointer;
            transition: 0.75s;
          }

          img:hover {
            transform: scale(1.2);
          }
        }

        .card_items {
          padding: 20px;

          h2 {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            font-size: 18px;
            color: #333333;
            line-height: 23px;
            margin-top: 1rem;

            a {
              cursor: pointer;
              color: #333333;
            }
          }

          h3 {
            cursor: pointer;
            text-transform: uppercase;
            font-size: 11.2776px;
            margin-top: -0.2rem;
            a {
              color: #2253f5;
            }
          }

          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;

            font-size: 13px;
            color: #333333;
            margin-top: -3px;
          }
        }
        @media (max-width: 768px) {
          margin: 0 auto;
          flex-direction: column;
          align-items: center;

          .cardblog {
            width: 280px;
            height: 400px;
            margin-right: 20px;

            &:last-child {
              margin-bottom: 2rem;
            }
          }
        }
      }
    }

  @media (max-width: 768px) {
    width: 100%;
    overflow: hidden;

    .container-results {
      width: 80%;

      .title-search > h1 {
        font-size: 1.5rem;
      }
    }

    .list-container {
      display: none;
    }

    .posts-content {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .category-information {
        width: 100%;
        margin-right: 2rem;
      }
    }

    .container-result {
      width: 80%;
    }

    .title_result > h1 {
      font-size: 1.5rem;
    }

    .posts-content_result {
      display: flex;
      flex-direction: column;

      .category-information_result {
        width: 100%;
        margin-right: 2rem;
      }
    }
  }
`;

export const ContainerPost = styled.div`
  position: relative;
  font-family: Montserrat !important;
  max-width: 1300px;
  height: auto;
  margin: 0 auto;

  .container-results_post {
    max-width: 842px;
    margin: 0 auto;
    margin-top: -11rem;

    .steps-result_post {
      font-size: 0.875rem;
      display: flex;
      align-items: center;
      color: #64728c;
      img {
        margin-left: 0.1rem;
        margin-right: 0.4rem;
      }

      a {
        text-decoration: none;
        color: #64728c;
      }

      .arrow-right-two {
        margin-left: 0.4rem;
      }
    }

    .title-search_post > h1 {
      font-family: 'Montserrat';
      font-weight: bold;
      font-size: 1rem;
      margin-top: 1.5rem;
      color: #2253f5;
      text-transform: uppercase;
    }

    .title-two {
      color: #333333;
      margin-top: 1rem;
      font-size: 2.5rem;
      font-weight: bold;
      line-height: 3rem;
      margin-bottom: -4rem;
    }
  }

  @media (max-width: 768px) {
    margin-left: 1rem;
    margin-top: 4rem;

    .container-results_post {
      margin-bottom: -9rem;
      .title-two {
        font-size: 1.5rem;
        line-height: 2rem;
      }

      .steps-result_post {
        font-size: 1rem;

        .title {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .home > img {
          margin-right: 1.5rem;
        }

        a {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  @media (max-width: 1440px) {
    margin-bottom: -21rem;
  }
`;

export const ContainerID = styled.div`
  position: relative;
  font-family: Montserrat;
  max-width: 1300px;
  height: auto;
  margin: 0 auto;

  .steps_result {
    display: flex;
    align-items: center;
    color: #64728c;
    font-size: 1rem;
    margin-bottom: 1rem;

    img {
      margin-left: 0.1rem;
      margin-right: 0.4rem;
    }
  }

  .container-result {
    max-width: 1268px;
    margin: 0 auto;
  }

  .title_result > h1 {
    font-family: Montserrat;
    font-size: 1.75rem;
    font-weight: normal;
    color: #2253f5;
    strong {
      &:first-child {
        margin: 0.4rem;
      }

      &:last-child {
        margin: 0.4rem;
      }
    }
  }

  .posts-content_result {
    display: flex;
    align-items: center;
    margin-left: 0.13rem;
    font-family: Montserrat;
    margin-top: 2.5rem;

    &:last-child {
      margin-bottom: 8.5rem;
    }

    a {
      text-decoration: none;
    }

    .category-information_result {
      width: 33.5rem;
      margin-left: 1.8125rem;

      a {
        text-decoration: none;

        h2 {
          font-family: Montserrat;
          font-weight: bold;
          font-size: 1.7rem;
          color: #333333;
          line-height: 38px;
          margin-top: 1.4rem;
        }

        p {
          font-weight: 300;
          font-size: 1rem;
          line-height: 25px;
          margin-top: 1rem;
          color: #333333;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }

      h3 {
        font-family: Montserrat;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12.645px;
        color: #2253f5;
      }
    }
  }

  .list-container {
    position: absolute;
    left: 1080px;
    top: 2px;
    width: 220px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }

  .list-items {
    padding: 1.3rem;
    display: flex;
    flex-direction: column;

    .newsletter {
      width: 100%;
      height: 40px;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1rem;
      text-transform: capitalize;
      font-weight: bold;
      color: #2253f5;
      background: #fcff7c;
      border-radius: 100px;
    }

    p {
      margin-bottom: -0.5rem;
      font-weight: 300;
      font-size: 16px;
      color: #2253f5;
    }

    a {
      text-decoration: none;
      font-size: 14px;
      color: #333333;
      text-transform: uppercase;
      margin-top: 1.5625rem;
      cursor: pointer;

      transition: all 0.2s ease-in-out;
    }

    a:hover {
      color: #2253f5;
      font-weight: bold;
      transform: scale(1.05);
    }
  }

  .container-results {
    max-width: 1268px;
    margin: 0 auto;
    margin-top: 6.25rem;
    height: 100%;

    .posts-content {
      display: flex;
      align-items: center;
      margin-left: 0.13rem;
      margin-top: 2rem;

      &:last-child {
        margin-bottom: 8.5rem;
      }

      a {
        text-decoration: none;
      }
    }

    .category-information {
      width: 33.5rem;
      margin-left: 1.8125rem;

      a {
        text-decoration: none;

        h2 {
          font-size: 1.7rem;
          color: #333333;
          line-height: 38px;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        p {
          font-weight: 300;
          font-size: 1rem;
          line-height: 25px;
          margin-top: -0.3rem;
          color: #333333;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }

      h3 {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12.645px;
        color: #2253f5;
      }
    }

    .steps-result {
      display: flex;
      align-items: center;
      color: #64728c;

      img {
        margin: 0.5rem;
      }
    }

    .steps-result_slug {
      display: flex;
      align-items: center;
      color: #64728c;
      img {
        margin-left: 0.1rem;
        margin-right: 0.4rem;
      }
    }

    .title-search > h1 {
      font-weight: bold;
      font-size: 2.5rem;
      margin-bottom: 4.375rem;
      color: #2253f5;
      text-transform: uppercase;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    overflow: hidden;

    .container-results {
      width: 80%;

      .title-search > h1 {
        font-size: 1.5rem;
      }
    }

    .list-container {
      display: none;
    }

    .posts-content {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .category-information {
        width: 100%;
        margin-right: 2rem;
      }
    }

    .container-result {
      width: 80%;
    }

    .title_result > h1 {
      font-size: 1.5rem;
    }

    .posts-content_result {
      display: flex;
      flex-direction: column;

      .category-information_result {
        width: 100%;
        margin-right: 2rem;
      }
    }
  }
`;

export const ContainerIDNoResult = styled.div`
  position: relative;
  font-family: Montserrat;
  max-width: 1300px;
  height: auto;
  margin: 0 auto;

  .list-results_noresult > h1 {
    font-family: Montserrat;
    font-size: 28px;
    color: #2253f5;
    font-weight: normal;

    strong:first-child {
      margin-left: 0.5rem;
    }
  }

  .steps-result_noresult {
    display: flex;
    align-items: center;
    color: #64728c;
    font-size: 1rem;
    margin-bottom: 1rem;

    img {
      margin-right: 0.4rem;
    }
  }

  .title_result > h1 {
    font-family: Montserrat;
    font-size: 1.75rem;
    font-weight: normal;
    color: #2253f5;
    strong {
      &:first-child {
        margin: 0.4rem;
      }

      &:last-child {
        margin: 0.4rem;
      }
    }
  }

  .list-container_noresult {
    position: absolute;
    left: 67.5rem;
    top: 0.2rem;
    width: 220px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;

    .list-items_noresult {
      padding: 1.3rem;
      display: flex;
      flex-direction: column;

      .newsletter_noresult {
        width: 100%;
        height: 40px;

        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 1rem;
        text-transform: capitalize;
        font-weight: bold;
        color: #2253f5;
        background: #fcff7c;
        border-radius: 100px;
      }

      p {
        margin-top: 0.8rem;
        margin-bottom: -0.725rem;
        font-weight: 300;
        font-size: 16px;
        color: #2253f5;
      }

      a {
        text-decoration: none;
        font-size: 14px;
        color: #333333;
        text-transform: uppercase;
        margin-top: 1.525rem;
        cursor: pointer;
        line-height: 1.13rem;

        transition: all 0.2s ease-in-out;
      }

      a:hover {
        color: #2253f5;
        font-weight: bold;
        transform: scale(1.05);
      }
    }
  }

  section.section-posts_noresult {
    margin-top: 19.625rem;
    width: 100%;
    background: #fff;

    h2:first-child {
      font-family: Montserrat;
      margin-bottom: 4.375rem;
      font-weight: bold;
      font-size: 2.5rem;
      color: #2253f5;
      text-transform: uppercase;
    }

    div.post {
      display: flex;
      justify-content: center;
      max-width: 1300px;
      margin: 0 auto;
      gap: 76px;

      .cardblog_noresults {
        width: 316px;
        height: 434px;
        background: #fff;
        box-shadow: 0px 3.67108px 14.6843px rgba(0, 0, 0, 0.15);
        border-radius: 11.0132px;
        overflow: hidden;

        &:last-child {
          margin-bottom: 7.6rem;
        }

        img {
          width: auto;
          height: auto;
          display: block;
          object-fit: cover;
          cursor: pointer;
          transition: 0.75s;
        }

        img:hover {
          transform: scale(1.2);
        }
      }
    }

    .card_items_noresult {
      padding: 20px;

      h3 {
        font-family: Montserrat;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 23px;
        margin-top: 1rem;

        a {
          cursor: pointer;
          color: #333333;
        }
      }

      h4 {
        font-family: Montserrat;
        cursor: pointer;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 11.2776px;
        margin-top: -0.55rem;
        a {
          color: #2253f5;
        }
      }

      p {
        font-size: 13px;
        line-height: 1rem;
        color: #333333;
        margin-top: 0.3rem;
      }
    }
  }

  @media (max-width: 768px) {
    width: 22rem;
    margin: 0 auto;
    overflow: hidden;

    .post {
      display: flex;
      flex-direction: column;
      margin: 0 auto;
    }

    .list-container_noresult {
      display: none;
    }
    .container-results {
      width: 100%;
    }

    .title_result > h1 {
      font-size: 1.5rem;
    }

    .section-posts_noresult {
      margin: 0 auto;
      flex-direction: column;
      align-items: center;

      h2:first-child {
        font-size: 1rem;
      }
    }
  }
`;

export const Newsletter = styled.div``;
